import { adminRoles } from '@/constants';
import { checkAndRedirectForOrgAdminAccess } from '@/helpers';
import { fetchOrganizations } from '@/pages/Organizations/orgUtils';
import { useAppStore } from '@/stores/app';
import { createFileRoute, redirect } from '@tanstack/react-router';

export const Route = createFileRoute('/organizations/')({
  beforeLoad: ({ context, location }) => {
    const store = useAppStore.getState();
    // Use selectedOrganization (runtime) if available, else fall back to selectedOrgStub (persisted)
    const selectedOrganization = store.selectedOrganization || store.selectedOrgStub;
    checkAndRedirectForOrgAdminAccess({
      context,
      location,
      selectedOrganization,
      adminRoles,
      redirect,
    });
  },
  loader: async () => {
    const orgs = await fetchOrganizations();
    return Array.isArray(orgs) ? orgs : [];
  },
});
